module.exports = __webpack_public_path__ + "img/phone.4cfa51ae.svg";